/*
 * iurop-featured — carrusel "Los más queridos".
 *   · Escritorio (>749px): coverflow — el activo grande en el centro (tarjeta-bolsa),
 *     los vecinos como foto a los lados; flechas + click lateral (wraparound).
 *   · Móvil (≤749px): scroll-snap táctil con peek a ambos lados, puntos de
 *     paginación y bucle infinito (tarjetas clonadas a los lados, así desde el
 *     origen se desliza tanto a izquierda como a derecha). Sin flechas.
 * Cambia de modo al cruzar el breakpoint (matchMedia, con teardown). Sin dependencias.
 */
(function () {
  var MQ = '(max-width: 749px)';

  function realSlides(track) {
    return Array.prototype.slice.call(
      track.querySelectorAll('.kawaii-feat__slide:not(.is-clone)')
    );
  }
  function clearModes(slides) {
    slides.forEach(function (s) {
      s.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden');
    });
  }

  // ---- Coverflow (escritorio) ---------------------------------------------
  function initCoverflow(root) {
    var track = root.querySelector('.kawaii-feat__track');
    if (!track) return;
    var slides = realSlides(track);
    var n = slides.length;
    if (!n) return;
    var ac = new AbortController();
    root._kfAbort = ac;
    var sig = ac.signal;
    var prev = root.querySelector('[data-kf-prev]');
    var next = root.querySelector('[data-kf-next]');
    var active = n >= 3 ? 1 : 0;

    function render() {
      for (var i = 0; i < n; i++) {
        var sl = slides[i];
        sl.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden');
        var d = i - active;
        if (n > 2) {
          if (d > n / 2) d -= n;
          if (d < -n / 2) d += n;
        }
        if (d === 0) sl.classList.add('is-active');
        else if (d === -1) sl.classList.add('is-prev');
        else if (d === 1) sl.classList.add('is-next');
        else sl.classList.add('is-hidden');
      }
    }
    function go(dir) { active = (active + dir + n) % n; render(); }

    if (prev) prev.addEventListener('click', function () { go(-1); }, { signal: sig });
    if (next) next.addEventListener('click', function () { go(1); }, { signal: sig });
    slides.forEach(function (sl, i) {
      sl.addEventListener('click', function (e) {
        if (!sl.classList.contains('is-active')) {
          e.preventDefault();
          active = i;
          render();
        }
      }, { signal: sig });
    });
    render();
  }

  // ---- Táctil: peek + puntos + bucle (móvil) ------------------------------
  function initMobile(root) {
    var track = root.querySelector('.kawaii-feat__track');
    var dotsWrap = root.querySelector('[data-kf-dots]');
    if (!track) return;
    var slides = realSlides(track);
    var n = slides.length;
    if (!n) return;
    var ac = new AbortController();
    root._kfAbort = ac;
    var sig = ac.signal;
    clearModes(slides);
    root.classList.add('is-touch');

    // Bucle: clonar juegos enteros a cada lado. Cuantos más, mayor el colchón
    // antes del borde del contenido → el bucle nunca "se para" aunque deslices
    // fuerte. Colecciones pequeñas/medianas (≤6) llevan 2 juegos; grandes, 1
    // (su propio tamaño ya hace de colchón).
    var CLONES = n === 1 ? 0 : (n >= 7 ? 1 : 2);
    if (CLONES > 0) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var c = 0; c < CLONES; c++) {
        slides.forEach(function (s) {
          var a = s.cloneNode(true);
          a.classList.add('is-clone'); a.setAttribute('aria-hidden', 'true'); a.tabIndex = -1;
          before.appendChild(a);
          var b = s.cloneNode(true);
          b.classList.add('is-clone'); b.setAttribute('aria-hidden', 'true'); b.tabIndex = -1;
          after.appendChild(b);
        });
      }
      track.insertBefore(before, slides[0]);
      track.appendChild(after);
    }
    var all = Array.prototype.slice.call(track.querySelectorAll('.kawaii-feat__slide'));
    var realStart = CLONES * n;
    var setW = 0;

    function measure() {
      setW = all.length > n ? (all[n].offsetLeft - all[0].offsetLeft) : 0;
    }
    function centerTo(idx, smooth) {
      var ch = all[idx];
      if (!ch) return;
      track.scrollTo({
        left: ch.offsetLeft + ch.offsetWidth / 2 - track.clientWidth / 2,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
    function nearestIdx() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
      for (var i = 0; i < all.length; i++) {
        var ch = all[i], cc = ch.offsetLeft + ch.offsetWidth / 2, dd = Math.abs(cc - c);
        if (dd < bd) { bd = dd; best = i; }
      }
      return best;
    }

    // Puntos: uno por producto real.
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      if (n > 1) {
        for (var i = 0; i < n; i++) {
          (function (i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'kawaii-feat__dot';
            b.setAttribute('aria-label', 'Ir al producto ' + (i + 1));
            b.addEventListener('click', function () {
              var base = Math.floor(nearestIdx() / n) * n; // 1er slide del juego actual
              centerTo(base + i, true);
            }, { signal: sig });
            dotsWrap.appendChild(b);
          })(i);
        }
      }
    }
    function syncDots() {
      if (!dotsWrap || !dotsWrap.children.length) return;
      var a = nearestIdx() % n;
      for (var i = 0; i < dotsWrap.children.length; i++) {
        dotsWrap.children[i].classList.toggle('is-on', i === a);
      }
    }
    // Marca la tarjeta centrada: solo ella lleva bolsa + plástico (Figma). Se
    // actualiza en vivo al scrollear; el CSS conserva el tamaño de caja para que
    // el scroll-snap no salte.
    function syncCenter() {
      var idx = nearestIdx();
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('is-center', i === idx);
      }
    }

    // Arranque: 1er producto real centrado (vecinas a ambos lados por los clones).
    measure();
    centerTo(realStart, false);
    syncDots();
    syncCenter();
    requestAnimationFrame(function () { measure(); centerTo(realStart, false); syncDots(); syncCenter(); });

    // Bucle: al asentarse el scroll, si el centro cayó en un juego clon, se
    // recoloca al juego real un salto idéntico (invisible) → bucle sin costura.
    var rt, ct, lastLeft = track.scrollLeft;
    track.addEventListener('scroll', function () {
      syncDots();
      // El "desplegado" de la bolsa NO se decide en caliente: pasando DOS
      // tarjetas de un gesto, la intermedia se marcaba centrada un instante y
      // su cromo se abria y cerraba (doble animacion, QA home movil). Pero
      // esperar al silencio total la hacia sentirse LENTA: se marca en cuanto
      // la velocidad cae (fase final del snap) — con impulso alto (cruzando
      // tarjetas) no se marca, asi que la intermedia sigue sin animarse.
      var v = Math.abs(track.scrollLeft - lastLeft);
      lastLeft = track.scrollLeft;
      clearTimeout(ct);
      if (v < 9) syncCenter();
      else ct = setTimeout(syncCenter, 60);
      if (!setW) return;
      clearTimeout(rt);
      rt = setTimeout(function () {
        var setIdx = Math.floor(nearestIdx() / n);
        if (setIdx !== CLONES) {
          track.scrollLeft += (CLONES - setIdx) * setW;
        }
      }, 70);
    }, { signal: sig, passive: true });

    window.addEventListener('resize', function () {
      measure();
      centerTo(nearestIdx(), false);
    }, { signal: sig });
  }

  // ---- Teardown / cambio de modo ------------------------------------------
  function teardown(root) {
    if (root._kfAbort) { root._kfAbort.abort(); root._kfAbort = null; }
    root.classList.remove('is-touch');
    var track = root.querySelector('.kawaii-feat__track');
    if (track) {
      Array.prototype.slice.call(track.querySelectorAll('.kawaii-feat__slide.is-clone'))
        .forEach(function (cl) { cl.remove(); });
      clearModes(realSlides(track));
      track.scrollLeft = 0;
    }
    var dotsWrap = root.querySelector('[data-kf-dots]');
    if (dotsWrap) dotsWrap.innerHTML = '';
  }

  function setup(root) {
    if (root.dataset.kfResponsive) return;
    root.dataset.kfResponsive = '1';
    var mq = window.matchMedia(MQ);
    var mode = null;
    function apply() {
      var want = mq.matches ? 'm' : 'd';
      if (want === mode) return;
      teardown(root);
      mode = want;
      if (want === 'm') initMobile(root); else initCoverflow(root);
    }
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-kf-carousel]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector('[data-kf-carousel]');
    if (c) { c.dataset.kfResponsive = ''; setup(c); }
  });
})();
